import slice from "./notificationsSlice";

export default slice.reducer;
